import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ButtonComponent, ButtonClass } from "@claas/claas-ui-components";
import {
  DialogModalComponent,
  ModalSize,
} from "@claas/claas-ui-components/layout/dialog-modal";
import { TranslateModule } from "@ngx-translate/core";
import { userContextStore } from "../../../../shared/data/user-context.store";

@Component({
  selector: "claas-change-country-dialog",
  templateUrl: "./change-country-dialog.html",
  styleUrls: ["./change-country-dialog.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DialogModalComponent, ButtonComponent, TranslateModule],
})
export class ChangeCountryDialogComponent {
  protected readonly store = inject(userContextStore);
  private readonly dialogRef = inject(
    MatDialogRef<ChangeCountryDialogComponent>,
  );

  protected readonly modalSize = ModalSize.SMALL;
  protected readonly buttonClass = ButtonClass;
  protected readonly selectedCountry = signal(this.store.country());

  protected select(country: string): void {
    this.selectedCountry.set(country);
  }

  protected confirm(): void {
    this.store.setCountry(this.selectedCountry());
    this.dialogRef.close();
  }

  protected cancel(): void {
    this.dialogRef.close();
  }
}
